/* ---- Be Neo MindMag — caixa de compra do braco de ASSINATURA ---------------
   Fork de `brainmag-pdp.js`, feito em 17/09/2026 para o teste de assinatura
   (ver docs/21-funil-assinatura-optout.md). O braco A segue com o arquivo
   original, intocado: os dois nunca renderizam juntos.

   O que muda em relacao ao A:
     - le DOIS produtos. `#lp-offer-data` traz o da ASSINATURA (com o `plan` de
       cada variante) e `#lp-once-data` traz o da COMPRA UNICA.
     - a caixa "Subscribe & Save" comeca MARCADA e decide qual variante vai para
       o carrinho. Marcada, adiciona a variante de assinatura com
       `selling_plan`; desmarcada, a variante avulsa.
     - a ancora e uma so e nao se mexe: o riscado do produto de compra unica.
       Marcar a caixa baixa o PRECO do card (e sobe o "Save %"); nunca troca a
       ancora. Tudo da loja, nada escrito aqui.
     - se NAO houver selling plan na variante (o app ainda nao criou os planos),
       a caixa nao aparece e a pagina vende so compra unica. E o estado em que a
       pagina nasce, e e por isso que ela pode subir antes do app estar pronto.

   Galeria e contador sao copia literal do A — `tests/paridade-sub.test.js`
   trava isso.
   -------------------------------------------------------------------------- */
(function () {
  var D = {};                    /* qty -> assinatura {variantId, price, ship, avail, plan} */
  var O = {};                    /* qty -> compra unica {variantId, once, ship, avail} */
  var QTYS = [];
  var qty = 0;
  var sub = true;                /* a caixa nasce marcada */

  /* Na moeda do visitante (Markets): '$' nos EUA, '£' no Reino Unido. O valor
     ja vem convertido pelo Liquid; aqui so troca o simbolo. */
  function usd(n) {
    var c = window.Shopify && Shopify.currency && Shopify.currency.active;
    return ({ GBP: '\u00a3', EUR: '\u20ac' }[c] || '$') + n.toFixed(2);
  }

  function lerJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function read() {
    var a = lerJson('lp-offer-data');
    if (!a || !a.items || !a.items.length) return false;
    a.items.forEach(function (it) {
      if (!it.qty) return;
      D[it.qty] = {
        variantId: it.variantId,
        price: (it.plan && it.plan.price != null ? it.plan.price : it.oncePrice) / 100,
        compare: it.comparePrice ? it.comparePrice / 100 : null,
        ship: parseFloat(it.ship) || 0,
        avail: it.available !== false,
        plan: it.plan || null
      };
      QTYS.push(it.qty);
    });
    var b = lerJson('lp-once-data');
    if (b && b.items) {
      b.items.forEach(function (it) {
        if (!it.qty) return;
        O[it.qty] = {
          variantId: it.variantId,
          once: it.oncePrice / 100,
          compare: it.comparePrice ? it.comparePrice / 100 : null,
          ship: parseFloat(it.ship) || 0,
          avail: it.available !== false
        };
      });
    }
    return QTYS.length > 0;
  }

  function temPlano() {
    return QTYS.some(function (q) { return D[q] && D[q].plan && D[q].plan.id; });
  }
  /* Modo assinatura de verdade: a caixa esta marcada E a variante tem plano. */
  function modoSub() { return sub && !!(D[qty] && D[qty].plan && D[qty].plan.id); }
  /* Preco avulso da quantidade. Sem o produto de compra unica na pagina, cai no
     proprio preco da assinatura — a pagina nunca fica sem preco. */
  function avulso(q) { return O[q] ? O[q].once : (D[q] ? D[q].price : 0); }
  /* Assinando? Entao o card e do produto de assinatura; senao, do avulso. */
  function subDe(q) { return sub && D[q] && D[q].plan; }
  /* A ANCORA e uma so e NAO se mexe: o riscado do produto de compra unica
     (84.99 / 254.97 / 424.95). Vale marcada ou desmarcada a caixa. O que muda
     e o preco PAGO — por isso o card mostra o preco pago e o "Save %" CRESCE
     quando a pessoa assina (61% -> 72%), em vez de a ancora encolher. Decisao
     do Matheus em 17/09: "o preco de ancora do One Time Purchase seria o preco
     de ancora tambem pro Subscription". */
  function precoCard(q) { return precoPago(q); }
  function precoPago(q) { return subDe(q) ? D[q].price : avulso(q); }
  function descontoSub(q) {
    if (!(D[q] && D[q].plan)) return 0;
    var cheio = avulso(q);
    return cheio > D[q].price ? Math.round((1 - D[q].price / cheio) * 100) : 0;
  }
  /* O RISCADO e SEMPRE o do produto de compra unica (frascos x 84.99),
     assinando ou nao. Trocar de ancora ao marcar a caixa encolhia a oferta em
     vez de aumenta-la, e foi o que derrubou a versao anterior. */
  function riscadoDe(q) {
    return ((O[q] && O[q].compare) || (D[q] && D[q].compare) || 0);
  }
  function ativo(q) { return (sub && D[q] && D[q].plan) ? D[q] : (O[q] || D[q]); }

  function pickDefault() {
    var flagged = document.querySelector('[data-mm-qty][data-mm-default]');
    if (flagged && D[+flagged.dataset.mmQty]) return +flagged.dataset.mmQty;
    return QTYS[Math.floor(QTYS.length / 2)] || QTYS[0];
  }

  /* A cadencia vem da loja, nunca daqui. Dois formatos chegam no `every`:
       - o Kaching publica um JSON  {"delivery":{"interval":"MONTH","frequency":3},...}
       - outros apps publicam texto  "3 months"
     Os dois caem aqui. Sem casar nenhum, devolve null e a data some do texto —
     nunca imprime o cru na tela. Medido em 17/09/2026, com os planos reais. */
  function cadencia(plan) {
    if (!plan) return null;
    var bruto = String(plan.every == null ? '' : plan.every);
    if (bruto.charAt(0) === '{') {
      try {
        var j = JSON.parse(bruto), d = j && (j.delivery || j.billing);
        if (d && d.interval) return { n: d.frequency || 1, unidade: String(d.interval).toLowerCase() };
      } catch (e) { /* cai no texto */ }
    }
    var m = /(\d+)\s*(day|week|month|year)/i.exec(bruto) ||
            /(\d+)\s*(day|week|month|year)/i.exec(String(plan.name || ''));
    if (m) return { n: parseInt(m[1], 10), unidade: m[2].toLowerCase() };
    var um = /every\s+(day|week|month|year)/i.exec(String(plan.name || '') + ' ' + bruto);
    if (um) return { n: 1, unidade: um[1].toLowerCase() };
    return null;
  }

  function proximaCobranca(c) {
    if (!c) return null;
    var d = new Date();
    if (c.unidade === 'day') d.setDate(d.getDate() + c.n);
    else if (c.unidade === 'week') d.setDate(d.getDate() + c.n * 7);
    else if (c.unidade === 'month') d.setMonth(d.getMonth() + c.n);
    else if (c.unidade === 'year') d.setFullYear(d.getFullYear() + c.n);
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch (e) { return null; }
  }

  function textoCadencia(plan) {
    var c = cadencia(plan);
    if (c) return c.n === 1 ? 'every ' + c.unidade : 'every ' + c.n + ' ' + c.unidade + 's';
    /* Ultimo recurso: o NOME do plano, que e texto de gente ("Delivery: every 3
       months"). O `every` cru nunca vai para a tela — no Kaching ele e um JSON. */
    return plan && plan.name ? String(plan.name).replace(/^\s*delivery\s*:\s*/i, '') : '';
  }

  function render() {
    var d = ativo(qty);
    if (!d) return;
    var emSub = modoSub();

    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      var q = +card.dataset.mmQty, k = ativo(q);
      card.setAttribute('aria-selected', q === qty);
      if (!k) { card.hidden = true; return; }

      var preco = precoCard(q), cheio = riscadoDe(q);

      var price = card.querySelector('[data-mm-price]');
      if (price) price.textContent = usd(preco);

      var was = card.querySelector('[data-mm-was]');
      var save = card.querySelector('[data-mm-save]');
      var temEconomia = cheio > preco;
      if (was) {
        if (temEconomia) { was.textContent = usd(cheio); was.hidden = false; }
        else { was.hidden = true; }
      }
      if (save) {
        if (temEconomia) {
          save.textContent = 'Save ' + Math.round((1 - preco / cheio) * 100) + '%';
          save.hidden = false;
        } else { save.hidden = true; }
      }

      var per = card.querySelector('[data-mm-per]');
      if (per) per.textContent = usd(preco / q) + ' a bottle';
    });

    var caixa = document.getElementById('mm-subbox');
    if (caixa) {
      caixa.hidden = !temPlano();
      var temP = !!(D[qty] && D[qty].plan);
      var pctSub = descontoSub(qty);

      /* A caixa NAO repete preco. Quem mostra preco e o card, um so, com a
         ancora parada atras dele. A caixa diz o que a assinatura ACRESCENTA:
         quantos por cento a mais. Repetir o preco aqui foi o bug de 17/09 — o
         mesmo 164.99 aparecia como "preco" no card e como "riscado" na caixa.
         O valor em dolar ("you keep $45.00") saiu a pedido dele: numero de dois
         digitos ao lado de preco de tres nao ajuda a oferta. */
      var pct = caixa.querySelector('[data-mm-save-pct]');
      if (pct) pct.textContent = pctSub > 0 ? 'an extra ' + pctSub + '%' : '';

      /* Liga a caixa ao card: marcada, o preco la em cima JA e o de assinante. */
      var ap = caixa.querySelector('[data-mm-applied]');
      if (ap) {
        ap.textContent = !temP ? '' :
          (sub ? 'already applied to the price above' : 'check it to drop the price above');
      }

      var cad = caixa.querySelector('[data-mm-cadence]');
      if (cad && temP) {
        cad.textContent = 'Delivered ' + textoCadencia(D[qty].plan) +
          ' \u00b7 cancel anytime \u00b7 this price is locked while you stay subscribed.';
      } else if (cad) { cad.textContent = ''; }
    }

    var btn = document.getElementById('mm-buy');
    if (btn) {
      var total = precoPago(qty);
      /* O riscado do botao e a MESMA ancora do card, assinando ou nao. Uma
         ancora por pagina. */
      var cheioBtn = riscadoDe(qty);
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(
        (emSub ? 'SUBSCRIBE & SAVE' : 'ADD TO CART') + ' \u00b7 ' + usd(total)
      ));
      if (cheioBtn > total) {
        var s = document.createElement('span');
        s.className = 'was';
        s.textContent = usd(cheioBtn);
        btn.appendChild(s);
      }
      btn.disabled = !d.avail;
    }

    var note = document.getElementById('mm-ship');
    if (note) {
      note.innerHTML = d.ship > 0
        ? 'Shipping ' + usd(d.ship) + ' \u2014 <b>free on 3 and 5 bottles</b>'
        : '<b>Free US shipping</b> on this bundle';
    }

    /* Os termos ficam colados ao botao, nao num link: valor, cadencia, data da
       proxima cobranca e como cancelar. Caixa marcada com termo escondido e o
       desenho que vira "assinei sem querer". */
    var termos = document.getElementById('mm-terms');
    if (termos) {
      if (emSub) {
        var p = D[qty].plan, quando = proximaCobranca(cadencia(p));
        /* O valor dos termos e o que o CARTAO paga, frete incluso. No pack de 1
           frasco o frete e cobrado na assinatura e em cada renovacao (o proprio
           consentimento da Shopify no checkout diz "plus shipping"). Mostrar
           so o preco do produto aqui subestimava a cobranca — e assinatura que
           cobra mais do que a pagina disse e disputa. */
        var frete = D[qty].ship > 0 ? ' + ' + usd(D[qty].ship) + ' shipping' : '';
        var valor = usd(D[qty].price) + frete;
        termos.textContent = valor + ' today, then ' + valor + ' ' +
          textoCadencia(p) + (quando ? ' (next charge around ' + quando + ')' : '') +
          ' until you cancel. We email you before every charge. ' +
          'Manage or cancel anytime in your Be Neo account \u2014 no phone call, no fee.';
        termos.hidden = false;
      } else {
        termos.textContent = '';
        termos.hidden = true;
      }
    }
  }

  function say(msg) {
    var el = document.getElementById('mm-err');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  /* Propriedades de linha: e o que o comprador ve no checkout, no e-mail e no
     pedido do admin. Mesma regra do A — todo numero e calculado, nunca escrito.
     No modo assinatura entra tambem a cadencia, porque e o que a pessoa precisa
     reconhecer quando a proxima cobranca chegar. */
  function oferta() {
    var props = {};
    var card = document.querySelector('[data-mm-qty="' + qty + '"]');
    var titulo = card && card.querySelector('.b-title');
    var emSub = modoSub();
    var preco = precoPago(qty);

    if (titulo && qty > 1) {
      props['Your offer'] = titulo.textContent.trim() + ' \u2014 ' + qty + ' bottles';
    }
    props['Price per bottle'] = usd(preco / qty);
    /* Sem "You save" no item, nos dois modos: pedido do Matheus em 18/09 — a
       linha no resumo do checkout nao ajudava a oferta. Ninguem le essa
       propriedade (nem teste, nem notificacao, nem AfterSell). */
    if (emSub) {
      props['Subscription'] = 'Delivered ' + textoCadencia(D[qty].plan) + ' \u2014 cancel anytime';
    }
    return props;
  }

  function adicionar(items) {
    var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
    if (cs) return cs.adicionar(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); });
  }

  function buy(ev) {
    if (ev) ev.preventDefault();
    var d = ativo(qty);
    if (!d) return say('Pick a bundle');

    var btn = document.getElementById('mm-buy');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var item = { id: d.variantId, quantity: 1, properties: oferta() };
    if (modoSub()) item.selling_plan = D[qty].plan.id;

    adicionar([item])
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        if (btn) btn.removeAttribute('aria-busy');
        console.error('[brainmag-sub] /cart/add.js falhou', e);
        say((e && e.description) || 'Could not add to cart \u2014 try again');
      });
  }

  /* ---- Galeria: slides, nao troca de src, para o srcset do beneo-img valer --
     Com 8 imagens (02/09/2026, antes 6) a miniatura sozinha nao da conta: no
     celular a fila rola de lado e as ultimas ficam fora da tela, entao quem so
     olha nem descobre que ha mais imagem. Dai as setas, o contador e o arrasto.
     -------------------------------------------------------------------------- */
  function gallery() {
    var slides = document.querySelectorAll('[data-mm-slide]');
    var thumbs = document.querySelectorAll('[data-mm-thumb]');
    var strip = document.querySelector('.thumbs');
    var count = document.querySelector('[data-mm-count]');
    var prev = document.querySelector('[data-mm-prev]');
    var next = document.querySelector('[data-mm-next]');
    var main = document.querySelector('.gallery-main');
    if (!slides.length) return;

    var at = 0;

    function show(i) {
      at = (i + slides.length) % slides.length;   /* circula nas duas pontas */
      slides.forEach(function (s, n) { s.setAttribute('data-on', n === at ? '1' : '0'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === at); });
      if (count) count.textContent = (at + 1) + ' / ' + slides.length;

      /* Centraliza a miniatura ativa na fila. So mexe no scroll HORIZONTAL da
         propria fila — scrollIntoView aqui arrastaria a pagina inteira. */
      var t = thumbs[at];
      if (t && strip && strip.scrollWidth > strip.clientWidth + 2) {
        strip.scrollTo({
          left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2),
          behavior: 'smooth'
        });
      }
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });

    /* Arrastar o dedo na imagem grande. Os 40 px de folga e a comparacao com o
       eixo Y existem para nao roubar o scroll de quem so esta descendo a pagina. */
    if (main) {
      var x0 = null, y0 = 0;
      main.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    show(0);
  }

  /* ---- Contagem regressiva do topo ----------------------------------------
     Sessao, nao data: um prazo real que expirasse deixaria a barra em 00:00:00
     no dia seguinte, que e pior do que nao ter barra. Reinicia a cada visita. */
  function timer() {
    var box = document.getElementById('mm-timer');
    if (!box) return;
    var left = (parseInt(box.dataset.minutes, 10) || 10) * 60;
    var h = box.querySelector('[data-t-h]'),
        m = box.querySelector('[data-t-m]'),
        s = box.querySelector('[data-t-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      if (left <= 0) { left = (parseInt(box.dataset.minutes, 10) || 10) * 60; }
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor(left / 60) % 60);
      if (s) s.textContent = pad(left % 60);
      left--;
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    gallery();
    timer();
    if (!read()) return;
    qty = pickDefault();
    sub = temPlano();
    var caixa = document.getElementById('mm-sub');
    if (caixa) {
      caixa.checked = sub;
      caixa.addEventListener('change', function () { sub = caixa.checked; render(); });
    }
    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      card.addEventListener('click', function () { qty = +card.dataset.mmQty; render(); });
    });
    var b = document.getElementById('mm-buy');
    if (b) b.addEventListener('click', buy);
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && b) b.removeAttribute('aria-busy');
      });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
